export const playerConstants = {

	/*
	 * Minimum player size for showing timeline controls
	 */
	PLAYER_MIN_WIDTH: {
		FULL_CONTROLS: 600,
		SEMI_FULL_CONTROLS: 300,
		BASIC_CONTROLS: 230,
		SINGLE_TIER: 430,
		SINGLE_TIER_SEARCH: 750,
	},

	/*
	 * Max width available cloud layout
	 */
	CLOUD_LAYOUT_MAX_WIDTH: {
		SMALL_SCREEN: 400,
		MEDIUM_SCREEN: 800,
	}
};